import { ConverterIF } from '@/components/Input/Converter/ConverterIF'
import '@/util/Extension/StringExtensions'

/**
 * 半角数字、カンマ、ハイフンのみを許容するinputクラス
 * カンマ区切りで複数指定、ハイフン繋ぎで範囲指定ができる
 */
export default class HalfNumberCommaHyphenConverter implements ConverterIF {
    /**
     * @brief	input要素のvalueの値を変換する
     * @param   [in]    target  対象のDOM情報
     * @return	変換後のvalue
     */
    public convertInputValue(target: HTMLInputElement): string {
        if (undefined == target || null == target) {
            return "";
        }

        if ("" === target.value) {
            return "";
        }

        // 制御コードを除外する
        let strReturn = target.value.removeControlCode();

        // 半角数字、カンマ、ハイフン以外は除外する
        strReturn = strReturn.replace(/[^0-9,-]/g, '');

        return strReturn;
    }

    /**
     * @brief	TextArea要素のvalueの値を変換する
     * @param   [in]    target  対象のDOM情報
     * @return	変換後のvalue
     */
    public convertTextAreaValue(target: HTMLTextAreaElement): string {
        // TextAreaには非対応のため空文字を返す。
        return "";
    }
}